import { hexToRgb } from './contrast-color.util';

/** Glossy-sphere box-shadow (innen abgetönte "Schale" + gestaffelter Außenschatten) für das
 * Icon-Badge, in der jeweiligen Kachel-Akzentfarbe statt neutralem Schwarz. */
export function getAccentBoxShadow(backgroundHex: string | undefined | null): string {
    const { r, g, b } = hexToRgb(backgroundHex ?? '#6366f1');
    const rgb = `${r}, ${g}, ${b}`;
    return [
        `rgba(${rgb}, 0.17) 0px -23px 25px 0px inset`,
        `rgba(${rgb}, 0.15) 0px -36px 30px 0px inset`,
        `rgba(${rgb}, 0.1) 0px -79px 40px 0px inset`,
        `rgba(${rgb}, 0.06) 0px 2px 1px`,
        `rgba(${rgb}, 0.09) 0px 4px 2px`,
        `rgba(${rgb}, 0.09) 0px 8px 4px`,
        `rgba(${rgb}, 0.09) 0px 16px 8px`,
        `rgba(${rgb}, 0.09) 0px 32px 16px`,
    ].join(', ');
}
